import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef} from '@angular/core';
import {FinanceProfileModel, FinanceWalletModel, ForecastModel} from '../../../../models/finance.model';
import {ModalService} from '../../../../services/modal/modal.service';
import {HelpersService} from '../../../../services/helpers.service';
import {FinanceService} from '../../../../services/api/finance.service';
import {AlertService} from '../../../../services/notify/alert.service';
import {TranslateService} from '@ngx-translate/core';

interface StructWalletInfo {
    totalBlocked: number;
    promised: number;
    promisedBlocked: number;
    expected: number;
    expectedBlocked: number;
}

@Component({
    selector: 'app-master-wallet',
    templateUrl: './master-wallet.component.html',
    styleUrls: ['./master-wallet.component.scss']
})
export class MasterWalletComponent implements OnInit, OnChanges {
    @Input() contractView = false;
    @Input() isLoadingData = false;
    @Input() isLoadingDataError = false;
    @Input() wallet: FinanceWalletModel;
    @Input() i = 0;
    @Input() forecastData: ForecastModel[];
    @Input() financeProfile: FinanceProfileModel;

    @Output() emitRefresh: EventEmitter<any> = new EventEmitter<any>();

    structWalletsInfo: {
        [key: string]: StructWalletInfo
    } = {};
    isShowReplenishmentModal = false;
    isShowPayoutModal = false;
    isShowBarterModal = false;
    showWallet = false;

    constructor(
        public modalService: ModalService,
        public helper: HelpersService,
        protected financeService: FinanceService,
        protected alert: AlertService,
        private translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        if (!this.contractView) {
            this.showWallet = this.wallet.is_master;
        } else {
            this.showWallet = true;
        }
        if (this.wallet.is_master) {
            this.loadForecastWallets(this.wallet.guid);
        }

        if (!this.forecastData) {
            this.financeService.getMoneyInfo().subscribe(res => {
                this.forecastData = res.forecast.forecast_wallets;
                if (this.contractView) {
                    this.loadForecastWallets(this.wallet.guid);
                }
            });
        }
    }

    getWallet(): void {
        this.financeService.getWalletByGuid(this.wallet.guid).subscribe({
            next: res => {
                this.wallet = res.wallet;
                this.loadForecastWallets(this.wallet.guid);
            }
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.wallet && !changes.wallet.firstChange) {
            this.loadForecastWallets(changes.wallet.currentValue.guid);
        }
        changes.forecastData ? this.loadForecastWallets(this.wallet.guid) : null;
    }

    swapSlider(): void {
        if (this.contractView) {
            return;
        }
        this.showWallet = !this.showWallet;
        this.loadForecastWallets(this.wallet.guid);
    }

    loadForecastWallets(guid: string): void {
        if (this.forecastData?.length === 0) {
            return
        }
        const forecastWallet = structuredClone(this.forecastData.find(forecast => forecast.wallet.guid === guid));
        this.structWalletsInfo[guid] = {
            expectedBlocked: forecastWallet.incoming_approved_total ? Number(forecastWallet.incoming_approved_total) : 0,
            expected: forecastWallet.incoming_promised_total ? Number(forecastWallet.incoming_promised_total) : 0,
            promisedBlocked: forecastWallet.outcoming_approved_total ? Number(forecastWallet.outcoming_approved_total) : 0,
            promised: forecastWallet.outcoming_promised_total ? Number(forecastWallet.outcoming_promised_total) : 0,
            totalBlocked: forecastWallet.outcoming_approved_total ? Number(forecastWallet.outcoming_approved_total) : 0,
        };
    }

    onShowBarterDialog(): void {
        if (this.wallet && this.wallet.active) {
            this.isShowBarterModal = true;
        } else {
            this.walletIsNotActiveAlert();
        }
    }

    onShowPayoutDialog(): void {
        if (this.wallet && this.wallet.active) {
            this.isShowPayoutModal = true;
        } else {
            this.walletIsNotActiveAlert();
        }
    }

    onShowReplenishmentDialog(): void {
        if (this.wallet.active) {
            if (this.wallet.is_master) {
                this.isShowReplenishmentModal = true;
            }
        } else {
            this.walletIsNotActiveAlert();
        }
    }

    walletIsNotActiveAlert(): void {
        this.alert.setAlert(this.translate.instant('ALERTS.BLOCKED_WALLET'), 'blue');
    }

    loadPaymentsHistory(selectWallet: FinanceWalletModel, modal?: TemplateRef<any>): void {
        this.wallet = selectWallet;
        this.financeService.getPaymentsHistory(this.wallet.guid).subscribe(ps => {
            this.wallet.payments = ps.payments?.data;
            this.modalService.openTemplateModal(modal);
        });
    }

    onCloseModal($event: boolean): void {
        if ($event) {
            this.getWallet();
        }
    }
}
